module.exports = __webpack_public_path__ + "a82e8e72359e8178198d2876883233a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/printIcon.png
// module id = 704
// module chunks = 0